<div class="flex flex-col p-5">
	<app-container class="flex-none p-1 pt-4">
		<app-matter-checklist></app-matter-checklist>
	</app-container>
	<div class="mt-8">
		<ui-content-header title="Notes" class="mb-4">
			<i-tabler title-action-left name="note" class="w-6 h-6"></i-tabler>
			<ui-button
				title-action
				label="Add"
				icon="plus"
				size="sm"
				preset="MEDIUM_EMPHASIS"
				(click)="createNote()"
				[testHook]="testHooks.AddButton"
			/>
		</ui-content-header>
		@if (notes_().length > 0) {
			<div class="flex flex-col gap-4">
				@for (note of notesToDisplay_(); track note.id) {
					<app-note [note]="note"></app-note>
				}
				@if (notes_().length > SHOW_NOTES_COUNT) {
					<div class="flex justify-center mt-5">
						<ui-button
							size="sm"
							preset="MEDIUM_EMPHASIS"
							(click)="toggleShowAllNotes()"
							[label]="showAllNotes_() ? 'Show less notes' : 'Show all notes'"
							[testHook]="testHooks.Button"
						>
						</ui-button>
					</div>
				}
			</div>
		}
	</div>

	<app-matter-overview-contacts class="mt-14"></app-matter-overview-contacts>
</div>

<app-matter-home-right-side id="matter-info"></app-matter-home-right-side>
